import { BaseLayout } from "@layouts/index";
import { SearchCard2 } from "@shared/cards";
import { FiltersCard } from "@shared/cards";

import { PropertyCardList } from "@lists/PropertyCardList";
// import { testimonials } from "./data";
// import { NewsCardList } from "@lists/NewsCardList";
// import { TestimonialCardList } from "@lists/TestimonialCardList";
import { createSearchParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { getProperties, getPropertyKinds } from "@services/krent.service";
import {
  PropertyKind,
  PropertyListResponse,
  PropertySummaryResponse,
} from "@interfaces/properties.interface";
import { BaseApiResponse, PaginatedResponse } from "@interfaces/app.interface";

import { NewsListResponse } from "@interfaces/news.interface";
import { SectionHeading } from "components/SectionHeading";
// import PopularLocation from "components/PopularLocation";
// import Services from "components/Services";
import NewsLetter from "components/NewsLetter";
import {
  addPageToSessionStorage,
  getPageFromSessionStorage,
} from "@utils/helpers";
import AdModal from "components/AdModal";
import AboutHome from "components/AboutHome";
import GetMeta from "@pages/SeoPages/GetMeta";

import CampaignHero from "components/LandingPage/campagin-hero";
import KrentSection from "@shared/cards/krentManaged";

export const Landing2 = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [shortletLoading, setShortletLoading] = useState<boolean>(false);
  const [propertyIntent, setPropertyIntent] = useState<string>("");

  const [properties, setProperties] = useState<PropertyListResponse[]>([]);
  const [shortletProperties, setShortletProperties] = useState<
    PropertyListResponse[]
  >([]);
  const [propertyKinds, setPropertyKinds] = useState<PropertyKind[]>([]);
  const [news, setNews] = useState<NewsListResponse[]>([]);
  const [adRight, setAdRight] = useState(0);
  const [page, setPage] = useState<any>(parseInt(getPageFromSessionStorage()));
  // const [vTourProperties, setVTourProperties] = useState<
  //   PropertyListResponse[]
  // >([]);
  // const [vTourLoading, setVTourLoading] = useState<boolean>(false);

  const [autoCompleteLocation, setAutoCompleteLocation] = useState<string>("");

  const navigate = useNavigate();

  const handleSearchTab = (int: any) => {
    let params: URLSearchParams = new URLSearchParams();

    if (int) params.append("intent", int);

    addPageToSessionStorage(1);
    setPropertyIntent(int);

    navigate(
      {
        pathname: "/explore/",
        search: `?${createSearchParams(params)}`,
      },
      { replace: false },
    );
  };

  useEffect(() => {
    setLoading(true);
    let abortController = new AbortController();
    getProperties({ intent: "long-lease" }, abortController.signal)
      .then(
        (
          res: BaseApiResponse<
            PropertyListResponse[],
            PaginatedResponse,
            PropertySummaryResponse
          >,
        ) => {
          setProperties(res.data);
        },
      )
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    setShortletLoading(true);
    let abortController = new AbortController();
    getProperties({ intent: "shortlet" }, abortController.signal)
      .then(
        (
          res: BaseApiResponse<
            PropertyListResponse[],
            PaginatedResponse,
            PropertySummaryResponse
          >,
        ) => {
          setShortletProperties(res.data);
        },
      )
      .catch(() => {})
      .finally(() => {
        setShortletLoading(false);
      });

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    let abortController = new AbortController();
    getPropertyKinds(abortController.signal)
      .then((res: BaseApiResponse<PropertyKind[], PaginatedResponse>) => {
        setPropertyKinds(res.data);
      })
      .catch(() => {})
      .finally(() => {});

    return () => {
      return abortController.abort();
    };
  }, []);

  useEffect(() => {
    let abortController = new AbortController();

    const nNews = async () => {
      const url = process.env["REACT_APP_BLOG_BASE_URL"];

      try {
        const res = await fetch(`${url}`);
        let result = await res.json();
        setNews(result);
        return result;
      } catch (error) {
        console.log(error);
      }
    };
    nNews();
    return () => {
      abortController.abort();
    };
  }, []);

  const maxPrice = properties
    .map((prop) => prop.price)
    .reduce((a, b) => {
      return Math.max(a, b);
    }, 0);
  return (
    <BaseLayout news={news} handleSearchTab={handleSearchTab}>
      <GetMeta
        description="Krent is a real estate and property listing website in Nigeria. Find homes to buy or rent from trusted landlords and agents. Sell your property or find a new home easily with our wide selection of flats, apartments, houses, and more"
        canonicalValue=" "
      />

      <CampaignHero />
      <div className=" container-fluid rounded pt-5 pb-5">
        <div className="w-sizing mx-auto  border rounded-30 p-1">
          <SearchCard2
            extraClass="rounded-top-left-0 rounded-top-right-0 "
            sizeClass="col-md-4 col-9"
            intent={propertyIntent}
            setPropertyIntent={setPropertyIntent}
            propertyTypes={propertyKinds}
            maxPprice={maxPrice}
            page={page}
            setPage={setPage}
          />
        </div>
      </div>

      <KrentSection />
      <section className="container ">
        <SectionHeading
          title="Top Rental Property Listings"
          text="Find your next home in minutes."
        />

        {!loading && properties.length === 0 ? (
          <p className="text-muted text-center py-4">
            No rental properties available at the moment. Check back soon.
          </p>
        ) : (
          <PropertyCardList
            properties={properties}
            loading={loading}
            items={3}
            showBtn={properties.length > 0}
            btnLink="/explore?intent=long-lease"
          />
        )}
      </section>

      <section className="container mt-5">
        <SectionHeading
          title="Top Shortlet Apartment Listings"
          text="Find your next home in minutes."
        />

        {!shortletLoading && shortletProperties.length === 0 ? (
          <p className="text-muted text-center py-4">
            No shortlet properties available at the moment. Check back soon.
          </p>
        ) : (
          <PropertyCardList
            properties={shortletProperties}
            loading={shortletLoading}
            items={3}
            showBtn={shortletProperties.length > 0}
            btnLink="/explore?intent=shortlet"
          />
        )}
      </section>

      <section className="container pb-5 px-4 px-md-3">
        <SectionHeading
          title="About Us"
          text="We are transforming the real estate market with technology that works and expertise you can trust "
        />
        <AboutHome />
      </section>

      <section className="">
        <div className="bg-primary p-5 p-md-0 px-md-5 px-lg-0 container-fluid">
          <NewsLetter />
        </div>
      </section>

      {news.length > 0 ? (
        <div
          className="position-fixed  "
          style={{
            bottom: "60%",
            right: `${adRight}rem`,
            zIndex: "99",
            background: "#282626",
            width: "18.75rem",
            height: "8.125rem",
            transition: "all 1s ease-in-out",
          }}
        >
          <AdModal news={news} />
          <span
            className="position-absolute "
            style={{
              top: "-10px",
              left: "-5px",
            }}
            onClick={() => {
              setAdRight(-50);
            }}
          >
            <i className="fa fa-x border border-secondary fs-8 p-1  rounded-pill bg-white text-dark-black cursor-pointer"></i>
          </span>
        </div>
      ) : (
        <span></span>
      )}
      <div
        className={`bg-primary position-fixed px-2 text-white cursor-pointer `}
        style={{
          height: "5rem",
          width: "1.5rem",
          bottom: "1rem",
          transition: "all 1s ease-in-out",
          right: ` ${adRight === 0 ? "-50rem" : "0"}`,
        }}
        onClick={() => setAdRight(0)}
      >
        <span>
          N <br></br>e<br></br>w<br></br>s
        </span>
        <span
          className=" cursor-pointer position-absolute"
          style={{ height: "8px", width: "8px", left: "-8px", top: "1.5rem" }}
        >
          <i className="fa fa-caret-left fs-20 p-1 text-primary cursor-pointer  "></i>
        </span>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title fw-bolder" id="offcanvasExampleLabel">
            Filters
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <FiltersCard
          autoCompleteLocation={autoCompleteLocation}
          setAutoCompleteLocation={setAutoCompleteLocation}
          page={page}
          limit={6}
          setPage={setPage}
        />
      </div>
    </BaseLayout>
  );
};
